export default "__VITE_ASSET__fe90be25__"